import { captureException } from "@sentry/react";

let config;

let defaultConfig = {
  environmentName: process.env.REACT_APP_DEV_ENV || "local",

  graphql: "",
  flask: "",
  web: "",
  ws: "",

  stripe: {
    unlimited_price_id_monthly: "price_1QfWuHI2vDgGH9ZgJdwiGl8S",
    unlimited_price_id_yearly: "price_1QfWuaI2vDgGH9ZgYd436n2c",
  },

  intercom: {
    intercom_id: "v8but558",
    intercom_enabled: false,
  },

  mixpanel: {
    id: "2843f411f4738d1a581a578f593c4311",
    enabled: false,
    debug: false,
    cookie_domain: ".scribenote.com",
    cross_subdomain_cookie: true,
  },

  launchdarkly: {
    client_key: "64e68a8c8fe28013699d2675",
  },

  sentry: {
    dsn: "https://2c03e9d93b444b8281f7d2ddce8c8eab@o362489.ingest.sentry.io/4215838",
    tracesSampleRate: 1.0,
    enabled: false,
  },

  isTestEnv: false,
  testUsers: [
    "alina@scribenote.com",
    "ryan@scribenote.com",
    "ayush@scribenote.com",
    "george@scribenote.com",
    "mala@scribenote.com",
    "pokemonvkn@gmail.com",
    "greg@scribenote.com",
    "sam@scribenote.com",
    "nathan@scribenote.com",
    "gary@scribenote.com",
  ],
};

function getEnvironmentDefaultConfig() {
  let envDefaultConfig = {
    ...defaultConfig,
  };
  if (envDefaultConfig.environmentName === "prod") {
    envDefaultConfig.graphql =
      "https://api-prod.scribenote.com/graphql";
    envDefaultConfig.flask = "https://api-prod.scribenote.com";
    envDefaultConfig.web = "https://app.scribenote.com";
    envDefaultConfig.ws = "wss://api-prod.scribenote.com";

    envDefaultConfig.stripe = {
      ...envDefaultConfig.stripe,
      unlimited_price_id_monthly: "price_1QfWavI2vDgGH9ZgWQT2ir3i",
      unlimited_price_id_yearly: "price_1QXT2aI2vDgGH9ZgK4PNxipu",
    };
    envDefaultConfig.intercom = {
      intercom_enabled: true,
      intercom_id: process.env.REACT_APP_INTERCOM_APP_ID,
    };

    envDefaultConfig.mixpanel = {
      id: "f38437e64ec9df766e801e31f06fe129",
      enabled: true,
    };

    envDefaultConfig.launchdarkly = {
      client_key: "64e68a8c8fe28013699d2676",
    };

    envDefaultConfig.sentry = {
      enabled: true,
    };

    envDefaultConfig.isTestEnv = false;
  } else if (envDefaultConfig.environmentName === "qa") {
    envDefaultConfig.graphql =
      "https://api-qa.scribenote.com/graphql";
    envDefaultConfig.flask = "https://api-qa.scribenote.com";
    envDefaultConfig.web = "https://qa.scribenote.com";
    envDefaultConfig.ws = "wss://api-qa.scribenote.com";

    envDefaultConfig.intercom = {
      intercom_enabled: true,
      intercom_id: "v8but558",
    };

    envDefaultConfig.mixpanel = {
      id: "4a601c05607c5442d1456c4812f4c577",
      enabled: true,
    };

    envDefaultConfig.sentry = {
      enabled: true,
    };

    envDefaultConfig.isTestEnv = true;
  } else if (envDefaultConfig.environmentName === "ci") {
    envDefaultConfig.graphql =
      "https://api-qa.scribenote.com/graphql";
    envDefaultConfig.flask = "https://api-qa.scribenote.com";
    envDefaultConfig.web = "https://qa.scribenote.com";
    envDefaultConfig.ws = "wss://api-qa.scribenote.com";

    envDefaultConfig.sentry = {
      enabled: true,
    };

    envDefaultConfig.isTestEnv = true;
  } else if (envDefaultConfig.environmentName === "development") {
    envDefaultConfig.graphql =
      "https://api-development.scribenote.com/graphql";
    envDefaultConfig.flask = "https://api-development.scribenote.com";
    envDefaultConfig.web = "https://dev.scribenote.com";
    envDefaultConfig.ws = "wss://api-development.scribenote.com";

    envDefaultConfig.intercom = {
      intercom_enabled: true,
      intercom_id: "v8but558",
    };

    envDefaultConfig.sentry = {
      enabled: true,
    };

    envDefaultConfig.isTestEnv = true;
  } else if (
    envDefaultConfig.environmentName === "development-sandbox-1"
  ) {
    envDefaultConfig.graphql =
      "https://api-development-sandbox-1.scribenote.com/graphql";
    envDefaultConfig.flask =
      "https://api-development-sandbox-1.scribenote.com";
    envDefaultConfig.web = "https://dev-1.scribenote.com";
    envDefaultConfig.ws =
      "wss://api-development-sandbox-1.scribenote.com";
  } else if (
    envDefaultConfig.environmentName === "development-sandbox-2"
  ) {
    envDefaultConfig.graphql =
      "https://api-development-sandbox-2.scribenote.com/graphql";
    envDefaultConfig.flask =
      "https://api-development-sandbox-2.scribenote.com";
    envDefaultConfig.web = "https://dev-2.scribenote.com";
    envDefaultConfig.ws =
      "wss://api-development-sandbox-2.scribenote.com";
  } else if (
    envDefaultConfig.environmentName === "development-sandbox-3"
  ) {
    envDefaultConfig.graphql =
      "https://api-development-sandbox-3.scribenote.com/graphql";
    envDefaultConfig.flask =
      "https://api-development-sandbox-3.scribenote.com";
    envDefaultConfig.web = "https://dev-3.scribenote.com";
    envDefaultConfig.ws =
      "wss://api-development-sandbox-3.scribenote.com";

    envDefaultConfig.isTestEnv = true;
  } else if (
    envDefaultConfig.environmentName === "local" ||
    envDefaultConfig.environmentName === "dev"
  ) {
    envDefaultConfig.graphql = "http://localhost:80/graphql";
    envDefaultConfig.flask = "http://localhost:80";
    envDefaultConfig.web = "http://localhost:3000";
    envDefaultConfig.ws = "ws://localhost:80";

    envDefaultConfig.isTestEnv = true;
  }

  return envDefaultConfig;
}

export function getConfig() {
  if (config) {
    return config;
  }
  try {
    if (!window.__SCRIBENOTE_CONFIG__) {
      console.log(
        "No config found, using environment default config",
      );
      config = getEnvironmentDefaultConfig();
    } else {
      console.log("Config found, using external config");
      let externalConfig = window.__SCRIBENOTE_CONFIG__;
      config = {
        ...defaultConfig,
        ...externalConfig,
      };
    }
    if (!config.graphql) {
      throw new Error("Environment configuration is incomplete");
    }
    return config;
  } catch (error) {
    console.error("Error getting configuration");
    captureException(error);
  }
}
